import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Fase 13.1 · devuelve la suscripción del usuario logueado + `hasAllAccess`.
 * Cachea el resultado en el estado del componente. `refresh()` fuerza re-fetch.
 * Si no hay sesión, devuelve `{ subscription: null, hasAllAccess: false }`.
 */
export function useSubscription() {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(!!user);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    if (!user) {
      setSub(null);
      setLoading(false);
      return Promise.resolve();
    }
    setLoading(true);
    return api
      .get("/subscriptions/me")
      .then((r) => {
        setSub(r.data);
        setError(null);
      })
      .catch((e) => {
        setError(e);
        setSub(null);
      })
      .finally(() => setLoading(false));
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    subscription: sub?.subscription || null,
    hasAllAccess: !!sub?.is_all_access_active,
    loading,
    error,
    refresh,
  };
}
